package pt.at.oss.kotlin.manual.schema.common.fixedestablishments

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.FIXED_ESTAB_TRADING_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.FIXED_ESTAB_TRADING_NAME_MIN_LEN
import pt.at.oss.kotlin.manual.schema.common.AddressSchema
import pt.at.oss.kotlin.manual.schema.common.VatIdSchema
import pt.at.oss.kotlin.manual.storage.common.fixedestablishments.FixedEstablishmentsEntry
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors

/**
 * FixedEstablishmentsEntrySchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class FixedEstablishmentsEntrySchema : RecordSchema<FixedEstablishmentsEntry>(name = "fixedEstablishments") {

    val taxIdentifSchema: VatIdSchema = VatIdSchema(name = "taxIdentif", isRequired = true)
    val tradingNameSchema: StringSchema = StringSchema(name = "tradingName", minLength = FIXED_ESTAB_TRADING_NAME_MIN_LEN, maxLength = FIXED_ESTAB_TRADING_NAME_MAX_LEN)
    val addressSchema: AddressSchema = AddressSchema()
    override fun isValid(value: FixedEstablishmentsEntry?): Boolean {
        return value == null || (
            taxIdentifSchema.isValid(value.taxIdentif) &&
                tradingNameSchema.isValid(value.tradingName) &&
                addressSchema.isValid(value.address)
            )
    }

    override fun validate(value: FixedEstablishmentsEntry?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(taxIdentifSchema.validate(value.taxIdentif))
        validator.addErrors(tradingNameSchema.validate(value.tradingName))
        validator.addErrors(addressSchema.validate(value.address))
        return validator
    }
}
